<script></script>

<div class="main">
        <div class="title">
            MARKETPLACE
        </div>
        <div class="img-wrapper">
            <img width="100%" height="100%" src="images/web3_pages/marketplace.png" alt="marketplace">
        </div>
        <div class="detail">
            <p>Building a global pool of brick-and-mortar merchants who accept FNFT.</p>
            <span>
                We have started with unregulated markets with high 
                inflation such as South East Asia and South America.
            </span>
        </div>
</div>

<style>
    .main{
        width: 33.854vw;
        height: 47.917vw;
        box-shadow: -0.208vw 0.208vw 0.417vw rgba(0, 0, 0, 0.8);
        border-radius: 2.083vw;
        position: relative;
        background-color: #FF007F;
        font-family: 'Montserrat';
        font-style: normal;
        color: #ffffff;
    }
    .title{
        font-weight: 900;
        font-size: 2.604vw;
        line-height: 74.5%;
        text-align: center;
        position: absolute;
        top: 3.365vw;
        left: 0;
        right: 0;
    }
    .img-wrapper{
        position: absolute;
        top: 8.254vw;
        left: 3.314vw;
        width: 26.927vw;
        height: 22.396vw;
    }
    .img-wrapper img{
        pointer-events: none;
    }
    .detail{
        width: 25.521vw;
        position: absolute;
        top: 32.167vw;
        left: 3.877vw;
    }
    .detail p{
        margin-top: 0;
        font-weight: 700;
        font-size: 1.563vw;
        line-height: 100%;
    }
    .detail span{
        font-weight:400;
        font-size: 1.563vw;
        line-height: 100%;
    }
</style>